import { createIdleLogout } from "@/hooks/createIdleLogout";
import { usePhysicianAuthStore } from "@/stores/physicianAuthStore";

export const useIdleLogout = createIdleLogout(usePhysicianAuthStore, "/physician/login");
